$(document).ready(function () {
  function convertToInches(cm) {
    const num = parseFloat(cm);
    if (isNaN(num)) return cm;
    return (num / 2.54).toFixed(1);
  }

  function buildTableFromText(wrapper) {
    const richText = wrapper.querySelector('.metafield-rich_text_field');
    const paragraph = (richText || wrapper).querySelector('p');
    if (!paragraph) return false;

    const html = paragraph.innerHTML;
    const text = html.replace(/<br\s*\/?>/gi, '\n');
    const lines = text.split('\n').map(l => l.trim()).filter(Boolean);
    if (lines.length === 0 || !lines[0].includes('|')) return false;

    const table = document.createElement('table');
    const tbody = document.createElement('tbody');

    lines.forEach((line, rowIndex) => {
      const cells = line.split('|').map(c => c.trim());
      const tr = document.createElement('tr');

      cells.forEach((value, cellIndex) => {
        const td = document.createElement('td');

        if (cellIndex === 0) {
          // Row label (SIZE, BUST, WAIST, etc.)
          td.className = 'table_head h7';
          td.textContent = value;
        } else if (rowIndex === 0) {
          // Size header row — same value for cm and in
          td.innerHTML = '<span class="cm">' + value + '</span><span class="in">' + value + '</span>';
        } else {
          // Measurement cell — cm value plus computed inch value
          const inchValue = convertToInches(value);
          td.innerHTML = '<span class="cm">' + value + '</span><span class="in">' + inchValue + '</span>';
        }

        tr.appendChild(td);
      });

      tbody.appendChild(tr);
    });

    table.appendChild(tbody);

    // Clear the wrapper entirely (removes .metafield-rich_text_field) and insert table directly
    wrapper.innerHTML = '';
    wrapper.appendChild(table);
    return true;
  }

  function setUnit(wrapper, unit) {
    // CSS handles showing/hiding .cm vs .in spans based on this attribute
    wrapper.setAttribute('data-unit', unit === 'in' ? 'in-inch' : 'in-cm');
  }

  // Build tables from pipe-separated text on load
  document.querySelectorAll('.size-guide-table').forEach((wrapper) => {
    buildTableFromText(wrapper);
  });

  // Wire up CM / IN toggles
  document.querySelectorAll('.size-unit-toggle').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-target');
      const wrapper = document.getElementById(targetId);
      if (!wrapper) return;

      const unit = this.getAttribute('data-class') === 'in-inch' ? 'in' : 'cm';
      setUnit(wrapper, unit);

      const footer = this.parentElement;
      footer.querySelectorAll('.size-unit-toggle').forEach((l) => l.classList.remove('active'));
      this.classList.add('active');
    });
  });
});